import type { IProduct } from '@/Interfaces/Product.interface';

export const getProductInventoryHint = ({
  publishers,
  domainsCount,
}: Pick<IProduct, 'publishers' | 'domainsCount'>) => {
  const parts: string[] = [];
  if (publishers?.length) parts.push(`${publishers.length} pubs`);
  if (domainsCount) parts.push(`${domainsCount} domains`);
  return parts.join(' · ');
};

export function filterByName<T extends { name: string }>(items: T[], searchTerm: string): T[] {
  if (!searchTerm) return items;
  return items.filter(item => item.name.toLowerCase().includes(searchTerm));
}
